import script from "./InspectionBatchPDFDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./InspectionBatchPDFDownload.vue?vue&type=script&setup=true&lang=ts"

import "./InspectionBatchPDFDownload.vue?vue&type=style&index=0&id=a265f696&lang=scss"

const __exports__ = script;

export default __exports__